import { useContext } from "react";

import BusinessContext from "contexts/BusinessContext";

const useBusiness = () => useContext(BusinessContext);

export default useBusiness;
